import React from "react"
import { Cell } from "fixed-data-table-2"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"

function getTip(children, sheetDataType) {
    switch (sheetDataType) {
        case DjangIO.app.models.QuorumDataType.bill.value:
            return DjangIO.app.userdata.types.SheetStanceVoteResultType.by_value(parseInt(children)).bill_sheet_tip

        default:
            return DjangIO.app.userdata.types.SheetStanceVoteResultType.by_value(parseInt(children)).cell_tip
    }
}

export const StanceCell = ({ children, ...props }) => (
    <div className="stance-cell">
        {
            children
                ? (
                    <Cell {...props}>
                        <Tooltip
                            label={getTip(children, props.sheetDataType)}
                        >
                            <Icon
                                name={DjangIO.app.userdata.types.SheetStanceVoteResultType.by_value(parseInt(children)).icon}
                            />
                        </Tooltip>
                    </Cell>
                )
                : (
                    <Cell {...props}>
                        {children}
                    </Cell>
                )
        }
    </div>
)
export default StanceCell
